export const TERMS_AND_AGREEMENT_MODAL_COOKIE_NAME = "applia-terms-modal";
